import axios from 'axios'

const NubelinkApi = axios.create({
  baseURL: import.meta.env.VITE_NUBELINK_API_URL,
})

NubelinkApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

export { NubelinkApi }
